module.exports = __webpack_public_path__ + "static/media/bulk_couriers_mark_deliver_sample.4a2baf2e.csv";